import { Breadcrumb } from "@/components";
import { LoadingSpinner } from "@/components/Loading";
import { useUserStore } from "@/store/userStore";
import { cn } from "@/utils";
import { useEffect, useState } from "react";
import { HiArrowLeft } from "react-icons/hi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Lessons } from "./Lessons";
import { Quizes } from "./Quizes";
import { ROUTES } from "@/constants/routes";

export enum LearningTab {
  LESSON = "lesson",
  QUIZ = "quiz",
}

export const KEYS_SEARCH_PARAMS = {
  TAB: "tab",
  SEARCH: "s",
  PAGE: "page",
};

export default function UserLearningDetail() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {
    currentUser,
    fetchUserById,
    setCurrentUser,
    setUserLessons,
    setUserQuizzes,
  } = useUserStore();

  const [loading, setLoading] = useState(false);

  const params = Object.fromEntries([...searchParams]);
  const tab = params[KEYS_SEARCH_PARAMS.TAB] || LearningTab.LESSON;

  const onBack = () => {
    navigate(-1);
    setTimeout(() => {
      setCurrentUser(null);
      setUserLessons({ data: null, status: 200 });
      setUserQuizzes({ data: null, status: 200 });
    }, 1000);
  };

  useEffect(() => {
    if (id && !isNaN(Number(id))) {
      setLoading(true);
      fetchUserById(Number(id))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      navigate(ROUTES.ERROR_404);
    }
  }, [id, fetchUserById]);

  const handleTabChange = (newTab: LearningTab) => {
    const updatedParams = { [KEYS_SEARCH_PARAMS.TAB]: newTab };
    setSearchParams(updatedParams, { replace: true });
  };

  const TabList = [
    {
      label: "学習",
      value: LearningTab.LESSON,
      isActive: tab === LearningTab.LESSON,
    },
    {
      label: "テスト",
      value: LearningTab.QUIZ,
      isActive: tab === LearningTab.QUIZ,
    },
  ];

  return (
    <div className="h-full flex flex-col pb-4">
      {/* header */}
      <section className="space-y-2 py-4">
        <Breadcrumb
          breadcrumbs={[
            { label: "事業所詳細", path: "/company" },
            { label: "店員詳細", path: "#" },
          ]}
        />
        <button
          className="flex items-center gap-2 text-base font-bold h-7 hover:text-cyan"
          onClick={onBack}
        >
          <HiArrowLeft className="w-5 h-5 hover:text-cyan" />{" "}
          {loading ? (
            <p className="h-2 w-24 bg-grey-300 animate-pulse rounded-full" />
          ) : (
            <p className="max-w-[32rem] truncate">{currentUser?.full_name || "-"}</p>
          )}
        </button>
      </section>

      <div className="flex gap-1 -ml-4 pl-4 relative">
        {TabList.map((tab) => (
          <button
            className={cn(
              " h-9.5 rounded-t-[0.25rem] px-4 border border-b-0 box-content text-sm hover:text-cyan",
              tab.isActive
                ? "bg-white z-10 text-cyan font-bold transition-all duration-200"
                : "bg-grey-300 border-grey-300 transition-all duration-200",
            )}
            key={tab.value}
            onClick={() => handleTabChange(tab.value)}
          >
            {tab.label}
          </button>
        ))}
        <div className="h-[1px] w-full bg-grey-300 absolute bottom-0 left-0" />
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-full w-full">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="relative w-full h-full">
          <div className={cn("absolute top-0 left-0 w-full h-full p-4 pl-0")}>
            {tab === LearningTab.LESSON ? <Lessons /> : <Quizes />}
          </div>
        </div>
      )}
    </div>
  );
}
